import React from 'react';
import { Link } from 'react-router-dom';
import 'animate.css';

import './home.css';

import logo from '../../assets/icons/logo-react.svg';
import bg from "../../assets/images/home-bg.webp";
// import logo2 from "../../assets/icons/logo-cbs.png";



function Home() {
    return(
        <div className='home' style={{ background: `url(${bg})`,
         backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
            <h2 className="title  animate__animated animate__zoomInDown">About</h2>
            <div className='home__container'>
                <div className='home__content'>
                    <div className='home__info animate__animated animate__backInRight'>
                        <p>Hello everyone!</p>
                        <p>My name is Vasyl.</p>
                        <p>I'm a Front-End Developer and I'd like to introduce you to my React app.</p>
                        <p>Yes, it's not perfect! But I'm working on it. And you can see for yourself. </p>
                        <p>I am constantly improving it, optimising the code, adding new functionality.</p>
                        <p>I've always liked multifunctionality. So I came up with the idea to combine useful applications into one. </p>
                        <p>So please rate it, give me feedback, share your ideas.</p>
                    </div>
                        <Link className="home__logo2 animate__animated animate__fadeInLeft" to="https://edu.cbsystematics.com/ua" target="_blank">
                        {/* <img className='home__svg' src={logo2} alt="logo" /> */}
                    </Link>
                </div>
                <img src={logo} className="home__logo" alt="logo" />
            </div>
        </div>
    );
}

export default Home;